/**
 * Updates the variable shortly after the user stops typing:
 * <search search-text="details.searchText"></search>
 */
export const SearchComponent = {
  bindings: {
    searchText: '=',
    onSearchChange: '&',
    placeHolderText: '@'
  },
  controller: function () {
    this.clearSearch = () => {
      this.searchText = '';
      this.onSearchChange({
        searchText: this.searchText
      });
    };
  },
  template: `
    <div class="input-group input-group-sm">
      <input data-test-selector="search-component" type="text" class="form-control" ng-attr-placeholder="{{$ctrl.placeHolderText ? $ctrl.placeHolderText : 'Find...'}}" ng-model="$ctrl.searchText"
           id="find"
           name="finds"
           aria-label="Find Search Field"
           ng-model-options="{ updateOn: 'default blur', debounce: { 'default': 300, 'blur': 0 } }"
           ng-change="$ctrl.onSearchChange({searchText: $ctrl.searchText})">
      <span class="input-group-addon apt-search-icon" ng-if="!$ctrl.searchText"></span>
      <span class="input-group-btn" ng-if="$ctrl.searchText.length > 0">
        <button class="btn btn-default apt-times-icon" type="button" aria-label="clear search" ng-click="$ctrl.clearSearch()"></button>
      </span>
    </div>`
};
